import { render, staticRenderFns } from "./RentalObjectProspectDetails.vue?vue&type=template&id=60c45c5d&"
import script from "./RentalObjectProspectDetails.vue?vue&type=script&lang=js&"
export * from "./RentalObjectProspectDetails.vue?vue&type=script&lang=js&"
import style0 from "./RentalObjectProspectDetails.vue?vue&type=style&index=0&id=60c45c5d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports